import { HorizontalBar, mixins } from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp],
  props: {
    options: {
      type: Object,
      default: {},
    },
    title: {
      type: String,
      default: null,
    },
    ctxStyles: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  },
  //* watch for dynamic updates to chart chartData
  watch: {
    chartData(to, from) {
      this.renderChart(this.chartData, this.options)
    },
  },
}
